export const AISLE = 'AISLE';
export const AISLE_AND_WINDOW = 'AISLE_AND_WINDOW';
//# sourceMappingURL=seatColumnTypes.js.map